// src/components/Services.js
import React, { useState } from 'react';
import { Code, Cloud, Database, Shield, ArrowRight } from 'lucide-react';
import '../styles/Services.css';

const Services = () => {
  const [activeService, setActiveService] = useState(0);

  const serviceTracks = [
    {
      icon: <Code className="service-track-icon" />,
      title: "Architecture & Build",
      description: "Enterprise-grade .NET applications built for scale, maintainability, and long-term reliability.",
      outcomes: [
        "Modular .NET Core architecture",
        "ASP.NET Web API design",
        "SQL Server schema optimization",
        "Code quality and standards"
      ],
      technologies: [".NET Core", "ASP.NET", "C#", "Web API", "SQL Server"],
      color: "from-blue-600 to-indigo-600"
    },
    {
      icon: <Cloud className="service-track-icon" />,
      title: "Cloud & DevOps",
      description: "Secure, scalable cloud infrastructure with automated deployment pipelines and continuous delivery.",
      outcomes: [
        "Azure/AWS cloud architecture",
        "CI/CD pipeline automation",
        "Docker containerization",
        "Infrastructure as Code"
      ],
      technologies: ["Azure", "AWS", "Docker", "Kubernetes", "Terraform"],
      color: "from-cyan-600 to-blue-600"
    },
    {
      icon: <Database className="service-track-icon" />,
      title: "Data & Performance",
      description: "Optimized database design, query tuning, and real-time observability for mission-critical systems.",
      outcomes: [
        "Database schema design",
        "Query optimization & indexing",
        "Performance monitoring",
        "Data migration strategies"
      ],
      technologies: ["SQL Server", "PostgreSQL", "Redis", "Application Insights"],
      color: "from-green-600 to-teal-600"
    },
    {
      icon: <Shield className="service-track-icon" />,
      title: "Reliability & Compliance",
      description: "End-to-end ownership of your business-critical systems—security hardening, backup/DR, and audit-ready documentation—backed by a 99.9% uptime SLA.",
      outcomes: [
        "Full ownership of uptime & system health",
        "Security baseline implementation",
        "Backup & disaster recovery",
        "Compliance audit support"
      ],
      technologies: ["24/7 System Ownership", "Security Audits", "DR Planning", "Documentation"],
      color: "from-orange-600 to-red-600"
    }
  ];

  return (
    <section id="solutions" className="services-section-enterprise">
      <div className="services-container-enterprise">
        <div className="section-header-center">
          <span className="section-badge">Our Solution Tracks</span>
          <h2 className="section-title">
            Four Tracks to Enterprise Reliability
          </h2>
          <p className="section-description">
            Comprehensive services designed to deliver measurable outcomes—from architecture to ongoing reliability.
          </p>
        </div>

        <div className="service-tracks-grid">
          {serviceTracks.map((track, index) => (
            <div
              key={index}
              onMouseEnter={() => setActiveService(index)}
              className={`service-track-card ${activeService === index ? 'track-active' : ''}`}
            >
              <div className={`track-header bg-gradient-to-br ${track.color}`}>
                <div className="track-icon-wrapper">
                  {track.icon}
                </div>
                <h3 className="track-title">{track.title}</h3>
              </div>

              <div className="track-content">
                <p className="track-description">{track.description}</p>

                <div className="track-outcomes">
                  <h4 className="outcomes-title">Key Outcomes:</h4>
                  <ul className="outcomes-list">
                    {track.outcomes.map((outcome, idx) => (
                      <li key={idx} className="outcome-item">
                        <ArrowRight className="outcome-icon" />
                        {outcome}
                      </li>
                    ))}
                  </ul>
                </div>

                <div className="track-technologies">
                  {track.technologies.map((tech, idx) => (
                    <span key={idx} className="tech-badge">
                      {tech}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;